import { createApp, h, Fragment } from 'vue'
import App from './App.vue';
import { store } from './store';
require('./normalize.css')

const setupApp = () => {
    app.use(store)
    app.mount('#app')
}

let app = null

// AXE seems to cause significant performance issues when using the filters drawer.
// Feel free to enable while developing while keeping this in mind
const disableAxe = true

if (!disableAxe && process.env.NODE_ENV === 'development') {
    import('vue-axe').then((res) => {
        const VueAxe = res.default
        const VueAxePopup = res.VueAxePopup
        app = createApp({
            render: () => h(Fragment, [h(App), h(VueAxePopup)]),
        })
        app.use(VueAxe)
        setupApp(app)
    })
} else {
    app = createApp(App)
    setupApp(app)
}
